const flourish = flourish || {};

(function ($, IntersectionObserver, matchMedia, document, window) {

	flourish.main = {

		animationDelay: 400,
		animationObserver: null,

		// Elements
		elem: {
			$backdrop: jQuery('.backdrop'),
			$body: jQuery('body'),
			$emergencyToggle: jQuery('.emergency-alert__trigger'),
			$header: jQuery('.global-header'),
			$main: jQuery('#main'),
			$menus: jQuery('.global-header__menus'),
			$mobileMenuToggle: jQuery('.global-header__menu-toggle'),
			$navigationPrimaryItem: jQuery('.global-header__menus .menu-item'),
			animatedElements: document.querySelectorAll('.animated')
		},

		// Media Query List
		mql: {
			large: window.matchMedia('(min-width: 1024px)')
		},

		// Initialize Function
		init: function () {
			this.bindUIActions();

			// If the browser supports the IntersectionObserver API,
			//  * Initialize the animationObserver
			//  * Set all animations to their starting state
			//  * Have animationObserver monitor each animation
			if(!!window.IntersectionObserver){
				flourish.main.animationObserver = new IntersectionObserver(flourish.main.animationStart, { rootMargin: '-100px', threshold: 0 });
				// We're not using forEach here because IE11 doesn't support it, and since we're already using a polyfill for the IntersectionObserver API let's not complicate things any further.
				for (let i = 0; i < this.elem.animatedElements.length; i = i +1) {
					this.elem.animatedElements[i].classList.add('animation-start');
					flourish.main.animationObserver.observe(this.elem.animatedElements[i]);
				}
			};
		},

		// Bind UI Actions
		bindUIActions: function () {
			this.elem.$emergencyToggle.on('click', this.emergencyToggle.bind(this));
			this.elem.$mobileMenuToggle.on('click', this.menuToggle.bind(this));

			jQuery(document).on('keydown', this.backdropClose.bind(this));
			this.elem.$backdrop.on('click', this.backdropClose.bind(this));
			this.elem.$main.on('focusin', this.backdropClose.bind(this));
			this.elem.$menus.on('focusin', this.backdropClose.bind(this));
			this.mql.large.addListener(this.backdropClose.bind(this));

			jQuery(document).on('scroll resize', this.onScroll.bind(this));
		},

		// If an item crosses the IntersectionObserver threshold, start any linked animations
		// Set the global animationDelay to zero to avoid frustration
		animationStart: function(entries) {
			let x = 0;
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					setTimeout(
						function (entry) {
							entry.target.classList.add('animation-end');
						}, 
						flourish.main.animationDelay * x,
						entry
					); 
					flourish.main.animationObserver.unobserve(entry.target);
					x = x + 1;
				};
			});
		},

		// Set the backdrop to close and open items to reset when:
		// * User presses the escape key
		// * User clicks the backdrop
		// * User tabs from the desktop search form to the menu or main content area
		// * User tabs from the mobile navigation to the main content area
		// * User reizes the browser across the header breakpoint
		backdropClose: function (e) {
			let activate = false;

			// Is the event a resolution change? Give it an automatic pass
			if (e.type === 'change') {
				activate = true;
			};

			// Is the event a click? Give it an automatic pass
			if (e.type === 'click') {
				e.preventDefault();
				activate = true;
			};

			// Is the event a focus change? Give it an a pass on desktop, or on mobile if tabbing to the main element ONLY
			if (e.type === 'focusin') {
				if (flourish.main.mql.large.matches) {
					activate = true;
				} else {
					if (e.currentTarget.localName === 'main') {
						activate = true;
					}
				}
			};

			// Is the event a keypress? Then only activate if escape is pressed and the backdrop is open
			if (e.type === 'keydown') {
				let code = (e.keyCode) ? e.keyCode : e.which;
				if (code === 27) {
					if (flourish.main.elem.$backdrop.hasClass('is-active')) {
						e.preventDefault();
						activate = true;
					}
				};
			};

			if (activate === true) {
				// Remove open/active states on all open/active elements
				flourish.main.elem.$body.removeClass('menu-open');

				flourish.main.elem.$backdrop.removeClass('is-active');
				flourish.main.elem.$header.removeClass('is-active');
				flourish.main.elem.$navigationPrimaryItem.removeClass('is-active');

				// Toggle aria attributes and classes on toggle buttons
				flourish.main.elem.$mobileMenuToggle.attr({
					'aria-label': 'Open Menu',
					'aria-expanded': 'false',
					'aria-pressed': 'false'
				});
			}
		},

		// Toggle emergency alert content {
		emergencyToggle: function(e) {
			e.preventDefault();
			let button = jQuery(e.currentTarget);
			button.attr({
				'aria-label': function (index, currentValue) {
					return (currentValue.indexOf('Show') > -1) ? currentValue.replace('Show', 'Hiden') : currentValue.replace('Hide', 'Show');
				},
				'aria-expanded': function (index, currentValue) {
					return (currentValue === 'true') ? 'false' : 'true';
				},
				'aria-pressed': function (index, currentValue) {
					return (currentValue === 'true') ? 'false' : 'true';
				}
			});
			jQuery(e.currentTarget).next('.emergency-alert__content')
				.attr({ 
					'aria-hidden': function (index, currentValue) {
						return (currentValue === 'true') ? 'false' : 'true';
					}
				})
				.slideToggle();
		},

		// Toggle display of mobile menu
		menuToggle: function(e) {
			e.preventDefault();
			let button = jQuery(e.currentTarget);

			// Toggle active class on body and global header
			flourish.main.elem.$body.toggleClass('menu-open');
			flourish.main.elem.$header.toggleClass('is-active');
			flourish.main.elem.$backdrop.toggleClass('is-active');

			// Toggle aria attributes and classes on button
			button.attr({
				'aria-label': function (index, currentValue) {
					return (currentValue.indexOf('Open') > -1) ? currentValue.replace('Open', 'Close') : currentValue.replace('Close', 'Open');
				},
				'aria-expanded': function (index, currentValue) {
					return (currentValue === 'true') ? 'false' : 'true';
				},
				'aria-pressed': function (index, currentValue) {
					return (currentValue === 'true') ? 'false' : 'true';
				}
			});

			// If open, and we're close to the top of the screen, slide up the Emergency Alert
			// We're doing this rather than scrolling, because it causes issues in mobile browsers
			if (flourish.main.elem.$body.hasClass('menu-open')) {
				jQuery('.emergency-alert').slideUp();
				// jQuery('html, body').animate({ scrollTop: flourish.main.elem.$header.offset().top }, 200);
			} else {
				jQuery('.emergency-alert').slideDown();
			}
		},

		// Adjust fixture on global header when scrolling
		onScroll: function () {
			let scrollPosition = window.pageYOffset || window.document.documentElement.scrollTop;
			let fixedPosition = flourish.main.elem.$main.offset().top
			let animatedPosition = fixedPosition + 150;

			if (scrollPosition >= fixedPosition) {
				// console.log('fixing');
				flourish.main.elem.$header.addClass('is-fixed');
			} else {
				// console.log('detaching');
				flourish.main.elem.$header.removeClass('is-fixed');
			}

			if (scrollPosition >= animatedPosition) {
				// console.log('animating');
				flourish.main.elem.$header.addClass('is-animated');
			} else {
				// console.log('un-animating');
				flourish.main.elem.$header.removeClass('is-animated');
			}
		}

	}

}(window.jQuery, window.IntersectionObserver, window.matchMedia, window.document, window));

const ready = () => {
	flourish.main.init();
};

window.addEventListener('DOMContentLoaded', ready, false);
jQuery(document).foundation();
